import { Range } from "immutable";

import { getAPI, getAllAPI, deleteAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";

export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_ERROR = "GET_USERS_ERROR";
export const GET_USERS_FINALLY = "GET_USERS_FINALLY";

export const GET_USER = "GET_USER";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";
export const GET_USER_FINALLY = "GET_USER_FINALLY";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
export const DELETE_USER_FINALLY = "DELETE_USER_FINALLY";

export const SET_USER_PAGE = "SET_USER_PAGE";
export const SET_USER_SORT = "SET_USER_SORT";

export const USER_CLEAR_ERROR = "USER_CLEAR_ERROR";
export const USER_CLEAR_FORM = "USER_CLEAR_FORM";

export const SET_DELETE_STATUS = "SET_DELETE_STATUS";

export const getAll = () => async (dispatch, getState, utils) => {
  const data = getState().user.meta.toJS();

  const action = GET_USERS;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = data => async (dispatch, getState, utils) => {
  const action = GET_USER;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const deleteOne = data => async (dispatch, getState, utils) => {
  const action = DELETE_USER;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      deleteAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );

    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = page => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_USER_PAGE,
    payload: { page }
  });

  dispatch(getAll());
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_USER_PAGE,
    payload: { page: 1 }
  });

  dispatch({
    type: SET_USER_SORT,
    payload: { field, dir }
  });

  dispatch(getAll());
};

export const clearError = field => ({
  type: USER_CLEAR_ERROR,
  payload: { field }
});

export const clearForm = () => ({
  type: USER_CLEAR_FORM
});

export const setDeleteStatus = status => ({
  type: SET_DELETE_STATUS,
  payload: { status }
});



// WEBPACK FOOTER //
// ./src/common/user/actions.js